import {PracticeStatus, PracticeTypes, ProcessingTypes} from './enums';
import {FileModel} from '../../claims-commons/models/file.model';
import {ESBContract, ESBCustomer, ESBFleetManager, ESBVehicle} from './claims-practice-contract.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class ClaimsPracticeModel implements ClaimsPractice {
	id: string;
	created_at: string;
	updated_at: string;
	created_by: string;
	status: PracticeStatus;
	practice_type: PracticeTypes;
	practice_id: string;
	parent_id: string;
	claim_id: string;
	processing_list: ProcessingItem[];
	attachment_list: FileModel[];
	contract: ESBContract;
	customer: ESBCustomer;
	vehicle: ESBVehicle;
	fleet_managers: ESBFleetManager[];
	finding?: PracticesFinding;
	misappropiation?: PraticesMisappropiation;
	seizure?: PraticesSeizure;
	releaseSeizure?: PraticesReleaseSeizure;
	theft?: PracticeTheft;

	constructor(model: ClaimsPracticeModel) {
		if (!Utilities.isVoid(model)) {
			Object.assign(this, model);
		}
	}
}


export interface ProcessingItem {
	processing_type: ProcessingTypes;
	processing_date?: string;
	working_number?: string;
	dossier_id?: string;
	working_id?: string;
	dossier_number?: string;
	processing_authority_date?: any;
	commodity_details?: Commoditydetails;
	status?: any;
	working_type?: string;
}

export class Commoditydetails {
	commodity_id: string;
	name: string;
	address: string;
	address_number: string;
	location: string;
	zip_code: string;
	province_code: string;
	phone: string;
	fax?: any;
	email: string;
}

export interface ClaimsPractice {
	id?: string;
	created_at?: string;
	updated_at?: string;
	created_by?: string;
	status?: PracticeStatus;
	practice_type?: PracticeTypes;
	practice_id?: string;
	parent_id?: string;
	claim_id?: string;
	processing_list?: ProcessingItem[];
	attachment_list?: FileModel[];
	contract: ESBContract;
	customer: ESBCustomer;
	vehicle: ESBVehicle;
	fleet_managers: ESBFleetManager[];
}

export interface PracticesFinding {
	finding_date: Date;
	finding_id: string;
	sequestered: boolean;
	provider: string;
	provider_code: string;
	complaint_police: boolean;
	complaint_cc: boolean;
	complaint_vvuu: boolean;
	complaint_gdf: boolean;
	authority_data: string;
	note?: string;
	hapened_abroad: boolean;
	found_location: string;
	province: string;
	state: string;
	double_key: boolean;
}

export interface PracticeTheft {
	theft_date: Date;
	theft_id: string;
	complaint_police: boolean;
	complaint_cc: boolean;
	complaint_vvuu: boolean;
	complaint_gdf: boolean;
	authority_data: string;
	note: string;
	happened_abroad: boolean;
	theft_location: string;
	province: string;

	// "theft_date": Date,
	// "theft_id": String,
	// "complaint_police": Boolean,
	// "complaint_cc": Boolean,
	// "complaint_vvuu": Boolean,
	// "complaint_gdf": Boolean,
	// "authority_data": String,
	// "note": String,
	// "happened_abroad": Boolean,
	// "theft_location": String,
	// "province": String

}

export interface PraticesMisappropiation {
	misappropriation_date: Date;
	misappropriation_id: string;
	provider: string;
	provider_code: string;
	complaint_police: boolean;
	complaint_cc: boolean;
	complaint_vvuu: boolean;
	complaint_gdf: boolean;
	authority_data: string;
	note: string;
	happened_abroad: boolean;
	sub_rental: string;
	plate: string;
	seizure: PraticesSeizure;
	finding: PracticesFinding;
}

export interface PraticesSeizure {
	seizure_date: Date;
	return_good_faith: boolean;
}

export interface PraticesReleaseSeizure {
	seizure_date: Date;
	release_from_seizure_date: Date;
	provider_code: string;
	provider: string;
	note: string;
}
